import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import '../types/app-terms.types';
import {
  CreateAppTermPayload,
  DeleteAppTermPayload,
  FetchTermsByCodePayload,
  IAppTerm,
  SaveTermsOrderPayload,
  UpdateAppTermPayload,
} from '../types/app-terms.types';

export const appTermsApi = createApi({
  reducerPath: 'appTermsApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api`),
  endpoints: (builder) => ({
    fetchTerms: builder.query<ApiPaginationResponse<IAppTerm[]>, void>({
      query: () => ({
        url: `/admin/terms-and-conditions`,
        method: 'GET',
      }),
    }),

    fetchTermsByCode: builder.query<ApiPaginationResponse<IAppTerm[]>, FetchTermsByCodePayload>({
      query: (payload) => ({
        url: `/invitations/${payload.invitation_code}/terms-and-conditions`,
        method: 'GET',
      }),
    }),

    createTerm: builder.mutation<ApiResponse<IAppTerm>, CreateAppTermPayload>({
      query: (payload) => ({
        url: `/admin/terms-and-conditions`,
        method: 'POST',
        body: payload,
      }),
    }),

    updateTerm: builder.mutation<ApiResponse<IAppTerm>, UpdateAppTermPayload>({
      query: (payload) => ({
        url: `/admin/terms-and-conditions/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    deleteTerm: builder.mutation<ApiResponse<void>, DeleteAppTermPayload>({
      query: (payload) => ({
        url: `/admin/terms-and-conditions/${payload.id}`,
        method: 'DELETE',
      }),
    }),

    saveTermsOrder: builder.mutation<ApiResponse<void>, SaveTermsOrderPayload>({
      query: (payload) => ({
        url: `/admin/terms-and-conditions/order`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyFetchTermsQuery,
  useCreateTermMutation,
  useUpdateTermMutation,
  useDeleteTermMutation,
  useSaveTermsOrderMutation,
  useLazyFetchTermsByCodeQuery,
} = appTermsApi;
